module.exports = __webpack_public_path__ + "img/edge_activites_bagage.5ef5b6b2.svg";